module.exports = __webpack_public_path__ + "media/images/jacques-730ceb6c.png";